import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';
import { MaterialModule } from './common/material.module';
import { WelcomeComponent } from './views/welcome/welcome.component';
import { P404Component } from './views/pages/404.component';
import { P500Component } from './views/pages/500.component';

// Import containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent
]


// Import components
import {
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV,
  AppUploadFileModule,
  AppSidebarFilterModule,
  AppWidgetsComponent,
  SearchLineComponent
} from './components';

const APP_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  AppWidgetsComponent,
  SearchLineComponent,
  APP_SIDEBAR_NAV
]

// Import directives
import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
} from './directives';

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
]

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import App Services
import { Auth0Service } from './common/services/auth0/auth0.service';
import { LocalstorageService } from './common/services/localstorage/localstorage.service';
import { AuthenticationService } from './views/authentication/authentication.service';
import { CanActivateAuthentication } from './views/authentication/authentication-can-activate.guard';
import { AppChartContractLinesService } from './components/app-chart-contract-lines/app-chart-contract-lines.service';
import { AppSidebarFilterService } from './components/app-sidebar-filter/app-sidebar-filter.service';
import { WelcomeModule } from './views/welcome/welcome.module';


// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { LocalizationModule, TranslationService, LocaleService } from 'angular-l10n';
import { FileUploadModule } from 'ng2-file-upload';
import { NgDraggableWidgetModule } from 'ngx-draggable-widget';
import { WelcomeService } from './views/welcome/welcome.service';
import { OptimizationGraphService } from './views/optimization-graph/optimization-graph.service';
import { AppProgressBarModule } from './components/app-progress-bar/app-progress-bar.module';
import { SearchLineService } from './components/app-search-line/app-search-line.service';

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    FileUploadModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    LocalizationModule.forRoot(),
    AppUploadFileModule,
    AppSidebarFilterModule,
    MaterialModule,
    NgDraggableWidgetModule,
    WelcomeModule,
    AppProgressBarModule
  ],
  declarations: [
    AppComponent,
    P404Component,
    P500Component,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: PathLocationStrategy
  },
  Auth0Service,
  LocalstorageService,
  AuthenticationService,
  CanActivateAuthentication,
  AppSidebarFilterService,
  WelcomeService,
  OptimizationGraphService,
  AppChartContractLinesService,
  SearchLineService
],
  bootstrap: [ AppComponent ]
})
export class AppModule {
  constructor(public locale: LocaleService, public translation: TranslationService) {
    this.locale.addConfiguration()
        .addLanguages(['en', 'es'])
        .setCookieExpiration(30)
        .defineLanguage('en')
        .defineDefaultLocale('en', 'US')
        .defineCurrency('USD');

    this.translation.addConfiguration()
        .addProvider('./assets/locale/locale-');

    this.translation.init();
}
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts